import { init } from "channelkart-mobility-bundle";
import { getLob } from "../../services/authenticationService";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { ApplicationInfo, AuthConfigType } from "../../types/types";
import { Action } from "../types";

function initiateRegistry(){
    const data = require("../../mergedSchema.json");
    const applicationInfo:ApplicationInfo = require("../../application.json");
    const egtmLobs:string[]=["pvmickind","default","pngckind","vblckind","mdlzckind","egtmckind","pepsicockind"];
    const usLobs:string[]=["bepensa", "cokerl"];
    const euLobs:string[]=["cokemrc","cokecv"];
    const alsafiLobs:string[]=["alsafisa"];
    const currLob:string  = getLob();
    if(egtmLobs.includes(currLob)){
        applicationInfo.SERVER_URL = EnvironmentRegistry.getUrl('prod-egtm');
    }
    else if(usLobs.includes(currLob)){
        applicationInfo.SERVER_URL = EnvironmentRegistry.getUrl('prod-us-west');
    }
    else if(euLobs.includes(currLob)){
        applicationInfo.SERVER_URL = EnvironmentRegistry.getUrl('prod-eu-south');
    }
    else if (alsafiLobs.includes(currLob)) {
        applicationInfo.SERVER_URL = EnvironmentRegistry.getUrl('prod-alsafi');
    }
    const authConfig: AuthConfigType = {
        ...applicationInfo,
        baseUrl: applicationInfo.SERVER_URL
    }
    EnvironmentRegistry.setEnvironment(applicationInfo.SERVER_URL);
    const dbName = "indexedDB_1.0.0";
    data.dbName = dbName;
    const dbConfig = data;
    const serviceRegistry = init({
        dbConfig,
        authConfig
    });
    (serviceRegistry.get('ConfigurationService') as any).getConfiguration('appContext').then((appContextInstance:any)=>{
        appContextInstance.mergeAppContext({})
    });
    return serviceRegistry;
}
export function ServiceRegistryReducer(state:any=initiateRegistry(),action:Action<any>){
    switch(action.type){
        case "setServiceRegistry":
            return initiateRegistry();
    }
    return state
}